export const ERROR_MESSAGES: Record<string, string> = {
  required: 'fieldErorrs.required',
  maxlength: `fieldErorrs.maxLength`,
  minlength: `fieldErorrs.minLength`,
  email: 'fieldErorrs.email',
  phone: 'fieldErorrs.phone',
  numbers: 'fieldErorrs.numbers',
  matching: 'fieldErorrs.matching',
};
